import { ensureIsoTimezone } from '@heidi/utils/dates';
import type { IntlShape } from 'react-intl';

/**
 * Compact relative run timestamps — e.g. ``today at 9:06 AM``,
 * ``yesterday at 9:01 AM``, ``Jul 13 at 9:05 AM``.
 */
export function formatRunSidebarLabel(
  iso: string,
  intl: IntlShape,
  now = new Date()
): string {
  const date = new Date(ensureIsoTimezone(iso));
  const time = intl.formatTime(date, {
    hour: 'numeric',
    minute: '2-digit',
  });

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const dayDiff = Math.round(
    (startOfToday.getTime() - startOfDate.getTime()) / 86_400_000
  );

  if (dayDiff === 0) {
    return intl.formatMessage(
      {
        defaultMessage: 'today at {time}',
        id: 'OLofOeTB/C',
        description: 'Compact timestamp for a workflow run from today',
      },
      { time }
    );
  }
  if (dayDiff === 1) {
    return intl.formatMessage(
      {
        defaultMessage: 'yesterday at {time}',
        id: 'CFT2ZholcN',
        description: 'Compact timestamp for a workflow run from yesterday',
      },
      { time }
    );
  }

  const day = intl.formatDate(date, { month: 'short', day: 'numeric' });
  return intl.formatMessage(
    {
      defaultMessage: '{day} at {time}',
      id: '3SlM/RZymb',
      description: 'Compact timestamp for an older workflow run',
    },
    { day, time }
  );
}
